import React, { useEffect, useState } from "react";
import {
    InputsContainer,
    InputsContainerBoldTitleTypography,
} from "./PostForm.styles";
import { UserConversationList } from "./ConversationList/UserConversationList";
import { UserConversationsForPost } from "./ConversationList/UserConversation.types";
import { getMappedUserConversationsForPost } from "../../../DataFetchers/PostDataFetcher";
import { isPlatformTippspiel } from "@infrastructure/Services/EnvService";
import { usePostFormModalStore } from "../../../Pages/GroupDetailsPage/Stores/PostFormModalStore";
import { useUserSimplifiedStore } from "@infrastructure/Persistence/useUserSimplifiedStore";
import { usePollOptionsState } from "./PollTab/PollOptionsState";

interface UserConversationListFacadeProps {
    onConversationSelect: (key: string) => void;
    selectedConversations: Array<string>;
}

export const UserConversationListFacade: React.FC<
    UserConversationListFacadeProps
> = ({ onConversationSelect, selectedConversations }) => {
    const { isPostFormModalOpen } = usePostFormModalStore();
    const { userId } = useUserSimplifiedStore();
    const [userConversationsList, setUserConversationsList] = useState<
        Array<UserConversationsForPost>
    >([]);
    const { setClosedAt } = usePollOptionsState();

    useEffect(() => {
        if (!isPlatformTippspiel) {
            return;
        }
        if (isPostFormModalOpen && userId) {
            getMappedUserConversationsForPost(userId).then(
                setUserConversationsList,
            );
        }

        return () => {
            setUserConversationsList([]);
            setClosedAt(undefined);
        };
    }, [isPostFormModalOpen, setClosedAt, userId]);

    if (!isPlatformTippspiel) {
        return null;
    }

    return (
        <InputsContainer>
            <InputsContainerBoldTitleTypography>
                Beitrag zusätzlich in deinen Chats posten?
            </InputsContainerBoldTitleTypography>
            <UserConversationList
                userConversationsList={userConversationsList}
                onConversationSelect={onConversationSelect}
                selectedConversations={selectedConversations}
            />
        </InputsContainer>
    );
};
